import i18n from "utils/i18n/i18n";

export default {
  assessmentInfo: i18n.t("student.pleaseComplete"),
};
